<template>
  <div class="border-layout">
    <div v-if="heading">
      <h2>&nbsp;{{ heading }}</h2>
    </div>

    <Toolbar>
      <template #left>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Месец:</span>
          <Calendar
            view="month"
            v-model="period"
            dateFormat="MM yy"
            :yearNavigator="true"
            yearRange="2020:2030"
            :showIcon="true"
            :showButtonBar="true"
            @month-change="refresh()"
          />
        </div>
      </template>
      <template #right>
        <Button icon="pi pi-print" class="p-mr-2" @click="onPrint" />
        <ToggleButton
          v-model="unofficial"
          @change="refresh()"
          onLabel="Справката е неофициална"
          offLabel="Справката е официална"
        />
      </template>
    </Toolbar>
    <div class="scrollable report-body">
      <div class="rpt">
        <div>
          <h1>{{ heading }}, ЕКО МАГ ЕООД</h1>
          <h2>{{ periodRender() }}</h2>
          <slot name="body" :data="data"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: {
    filter: null, // при опресняване на филтър на данните// ({query: ''})
  },
  data() {
    return {
      data: {},
      unofficialReport: false,
      date: new Date(),
    };
  },

  props: {
    resource: String,
    heading: String,
  },

  mounted() {
    this.refresh();
  },

  methods: {
    onPrint() {
      window.print();
    },
    getPeriodFromDate() {
      return this.period.getFullYear() * 100 + this.period.getMonth() + 1;
    },
    refresh() {
      var ctx = this;
      this.loading = true;
      var event = {
        onSuccess: function (data) {
          ctx.data = data;
          ctx.loading = false;
        },
        onFailure: function (error) {
          ctx.loading = false;
          ctx.handleError(error);
        },
      };
      var params = {
        period: this.getPeriodFromDate(),
        unofficial: this.unofficial,
      };
      this.$emit("filter", params);
      this.$http
        .get(this.resource, { params: params })
        .then((res) => event.onSuccess(res.data))
        .catch((res) => event.onFailure(res));
    },
    periodRender() {
      return (
        this.$primevue.config.locale.monthNames[this.date.getMonth()] +
        ", " +
        this.date.getFullYear()
      );
    },
  },

  computed: {
    period: {
      get() {
        return this.date;
      },
      set(date) {
        this.date = date;
        this.refresh();
      },
    },
    unofficial: {
      get() {
        return this.unofficialReport;
      },
      set(unofficial) {
        this.unofficialReport = unofficial;
        this.refresh();
      },
    },
  },
};
</script>

<style>
.rpt {
  display: flex;
  margin: auto;
  width: auto;
}

.rpt h1,
.rpt h2 {
  text-align: center;
}

.rpt > div {
  margin: 1pt auto;
  display: block;
  position: relative;
  width: auto;
}

.rpt table {
  border-collapse: collapse;
}

.rpt td,
.rpt th {
  padding: 0.4em;
}

.rpt table thead tr:first-child th {
  position: sticky;
  top: 0;
}

.rpt table thead tr:last-child th {
  position: sticky;
  top: 2em;
}

.number {
  width: 7em;
}
</style>
